import { Checkbox, Table } from "antd";
import { useGetAllIR8AFormsQuery } from "AppQuries/government/iras/ir8a";
import YearOption from "Components/Form/YearSelect";
import ReportTools from "Components/UI/ReportTools";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { loggedInUser } from "core/redux/slice/authSlice";
import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Edit, Eye, PlusCircle, Trash } from "react-feather";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";

const IR8AFormList = () => {
  const userData = useSelector(loggedInUser);
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [filter, setFilter] = React.useState({
    companyCode: userData?.companyCode,
    employeeCode: 0,
    isApproved: null,
    isSubmission: null,
    year: new Date().getFullYear(),
  });

  const {
    data: formDataList,
    isFetching,
    isError,
    error,
  } = useGetAllIR8AFormsQuery(filter);

  console.log(formDataList);

 const yearSelectHandler = (year) => {
  setFilter((prev) => ({ ...prev, year: year }));
};
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const handleSelect = (record, selected) => {
    if (selected) {
      setSelectedRowKeys((keys) => [...keys, record.key]);
    } else {
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.key);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });
    }
  };

  const toggleSelectAll = () => {
    setSelectedRowKeys((keys) =>
      keys.length === formDataList.length ? [] : formDataList.map((r) => r.key),
    );
  };

  const headerCheckbox = (
    <Checkbox
      checked={selectedRowKeys.length}
      indeterminate={
        selectedRowKeys.length > 0 &&
        selectedRowKeys.length < formDataList.length
      }
      onChange={toggleSelectAll}
    />
  );

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    fixed: true,
    onSelect: handleSelect,
    columnTitle: headerCheckbox,
    //onSelectAll: this.handleSelectAll
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      key: "uniqueID",
    },
    {
      title: "Emp Name",
      dataIndex: "employeeName",
      key: "employeeName",
    },
    {
      title: "Yead",
      dataIndex: "basisYear",
      key: "basisYear",
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          {/* <Link
              className="me-2 p-2"
              to={`${all_routes.shift}${all_routes.shift_policy}${all_routes.edit_shift_policy}/${record.shiftPolicyID}`}
            >
              <Eye className="feather-view" />
            </Link> */}
          {/* <Can
            accessModule={accessCodes.shift_management}
            accessCode={accessCodes.shift_policy}
            accessType="haveEdit"
          > */}

          <Link
            className="me-2 p-2"
            to={`${all_routes.ir8a_edit_form}/${record.id}`}
          >
            <Edit className="feather-edit" />
          </Link>
          {/* </Can> */}
          {/* <Link
              className="me-2 p-2"
              to={`${all_routes.shift}${all_routes.shift_policy}${all_routes.edit_shift_policy}/${record.shiftPolicyID}`}
            >
              <Trash className="feather-trash" />
            </Link> */}
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    formDataList,
    searchColumns,
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>IR8A Form</h4>
              <h6>View and manage IR8A forms</h6>
            </div>
          </div>
          <ReportTools
            columns={[]}
            data={[]}
            fileName={`IR8A Form List - ${new Date().toLocaleDateString()}`}
            pdfTheme="striped"
            // refresh={getReport}
            refresh={() => {
              // setSelectedRowKeys([]);
              // getReport();
            }}
          />
          <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="add-new-tooltip">Generate IR8A Forms</Tooltip>
              }
            >
              <Link
                to={`${all_routes.ir8a_generateForm}`}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Generate Form
              </Link>
            </OverlayTrigger>
          </div>
        </div>
        <div className="card table-list-card border-0">
          <TableTop
            onSearch={setSearchValue}
            toggleFilterVisibility={toggleFilterVisibility}
            isFilterVisible={isFilterVisible}
            showToggle={true}
          />
          <div
            className={`card${isFilterVisible ? " visible" : ""}`}
            id="filter_inputs"
            // style={{ display: isFilterVisible ? "block" : "none" }}
          >
            <div className="card-body pb-0">
              <div className="form-row row">
                <div className="row">
                  {/* <div className="col-lg-3 col-sm-6 col-12 mb-3">
                    <div className="form-group">
                      <label className="form-label">Employee </label>

                      <Select
                        className="select"
                        options={employeeOptions}
                        placeholder="Employee"
                        value={employeeOptions.find(
                          (option) => option.value === employeeCode,
                        )}
                        onChange={(e) => {
                          setEmployeeCode(e?.value || 0);
                        }}
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="absolute"
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            zIndex: 111,
                          }),
                          menuPortal: (baseStyles) => ({
                            ...baseStyles,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>
                  </div> */}

                  <div className="col-lg-3 col-sm-6 col-12 mb-3">
                    <div className="form-group">
                      <label className="form-label">Year</label>
                      <YearOption
                        selectedYear={filter?.year}
                        yearSelectHandler={yearSelectHandler}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <label className="form-label">&nbsp;</label>
                      <Link
                        className="btn btn-filters ms-auto"
                        onClick={() => {
                          // setSelectedRowKeys([]);
                          // getReport();
                        }}
                        type="button"
                      >
                        <i data-feather="search" className="feather-search" />
                        {/* {isFetching ? ( */}
                        <>
                          Filter
                          {/* <i className="fas fa-spinner fa-spin me-2"></i>
                          Loading... */}
                        </>
                        {/* ) : (
                          <>Filter</>
                        )} */}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body border-0">
            {/* <div className="card-header">
                <h4 className="card-title">Advance Payment Details</h4>
              </div> */}

            <div className="row">
              <div className="col-md-12">
                <div className="table-list-card">
                  <div className="table-responsive">
                    <Table
                      loading={isFetching}
                      columns={columns}
                      dataSource={filteredData}
                      rowKey="uniqueID"
                      pagination={false}
                      bordered
                      // scroll={{ x: 1500 }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IR8AFormList;
